// Argus — ArgusDialog: wrapper reusable peste MUI Dialog cu structura standard
// DialogTitle / DialogContent (overflow Y auto, X hidden) / DialogActions slots.
// Folosit pentru toate dialogurile non-floating (Lightbox, FilePreview, Properties etc.).
// ReAuthModal păstrează MUI Dialog direct (full-screen blocking flow).

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Box,
  type Breakpoint,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import type { ReactNode } from 'react';

export interface ArgusDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
  actions?: ReactNode;
  minWidth?: number;
  maxWidth?: Breakpoint | false;
  fullWidth?: boolean;
  hideClose?: boolean;
  contentSx?: object;
}

export function ArgusDialog({
  open,
  onClose,
  title,
  children,
  actions,
  minWidth = 800,
  maxWidth = 'lg',
  fullWidth = true,
  hideClose = false,
  contentSx = {},
}: ArgusDialogProps): JSX.Element {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      slotProps={{
        paper: {
          sx: {
            minWidth,
            maxHeight: 'calc(100vh - 64px)',
          },
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1.25, pr: 1 }}>
        <Box sx={{ flexGrow: 1, fontSize: '1rem', fontWeight: 600 }}>{title}</Box>
        {!hideClose ? (
          <IconButton onClick={onClose} size="small" aria-label="Close">
            <CloseIcon fontSize="small" />
          </IconButton>
        ) : null}
      </DialogTitle>
      <DialogContent
        dividers
        sx={{
          overflowX: 'hidden',
          overflowY: 'auto',
          p: 0.5,
          ...contentSx,
        }}
      >
        {children}
      </DialogContent>
      {actions ? <DialogActions>{actions}</DialogActions> : null}
    </Dialog>
  );
}
